import React, {forwardRef} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {notificationClickState} from '../../helpers/notificationClick';

const isModified = (event) => event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;

/**
 * `Link` de card de notificação. O clique comum navega com um valor novo no estado da localização
 * (ver `helpers/notificationClick`), então a tela de destino refaz a seleção até quando já está
 * aberta com a mesma URL. `replace` substitui a entrada atual em vez de empilhar. Clique com tecla
 * modificadora, de outro botão ou com `target` segue o comportamento normal do link, e um `onClick`
 * que cancela o evento impede a navegação.
 *
 * @param {Object} props as do `Link`; `to` é uma URL em texto
 * @param {Object} ref repassada ao elemento `<a>`
 * @return {JSX.Element} o link
 */
const NotificationLink = forwardRef(({to, onClick, target, replace, ...props}, ref) => {
  const history = useHistory();
  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
    if (!event.defaultPrevented && event.button === 0 && !target && !isModified(event)) {
      event.preventDefault();
      (replace ? history.replace : history.push)(to, notificationClickState());
    }
  };
  return <Link ref={ref} to={to} target={target} replace={replace} onClick={handleClick} {...props} />;
});

NotificationLink.displayName = 'NotificationLink';

export default NotificationLink;
